const relationship =  [
  {
    label: '父',
    value: '父'
  },
  {
    label: '母',
    value: '母'
  },
  {
    label: '夫',
    value: '夫'
  },
  {
    label: '妻',
    value: '妻'
  },
  {
    label: '兄弟（姉妹）',
    value: '兄弟（姉妹）'
  },
  {
    label: '長男',
    value: '長男'
  },
  {
    label: '次男',
    value: '次男'
  },
  {
    label: '三男',
    value: '三男'
  },
  {
    label: '長女',
    value: '長女'
  },
  {
    label: '三女',
    value: '三女'
  },
  {
    label: '次女',
    value: '次女'
  },
  {
    label: '義父',
    value: '義父'
  },
  {
    label: '義母',
    value: '義母'
  },
  {
    label: '妻夫',
    value: '妻夫'
  },
  {
    label: '孫',
    value: '孫'
  },
  {
    label: '2親等内親族',
    value: '2親等内親族'
  }
]

export { relationship }